import { CardElement as StripeCardElement, CardElementProps as StripeCardElementProps } from '@stripe/react-stripe-js'
import { StripeCardElementChangeEvent } from '@stripe/stripe-js'
import { useField } from 'formik'
import React, { useEffect, useState } from 'react'
import { ObjectSchema, addMethod, object } from 'yup'

import { ElementState } from './ElementState'

export interface CardElementProps extends StripeCardElementProps {
  name: string
}

const CardElement: React.FC<CardElementProps> = ({ name, onBlur, onChange, ...props }) => {
  const [, , { setTouched, setError }] = useField<ElementState>(name)
  const [, { value: firstName }] = useField('firstName')
  const [errorMessage, setErrorMessage] = useState('')

  const handleChange = (event: StripeCardElementChangeEvent) => {
    setTouched(true)
    if (firstName && firstName.includes('PHONE PAYMENT')) {
      setError(undefined)
      setErrorMessage('')
    } else if (event.error) {
      setError(event.error.message)
      setErrorMessage(event.error.message)
    } else {
      setError(undefined)
      setErrorMessage('')
    }
    onChange?.(event)
  }

  const handleBlur = () => {
    onBlur?.()
  }

  return (
    <div>
      <div>
        <StripeCardElement {...props} onBlur={handleBlur} onChange={handleChange} />
      </div>
      {errorMessage && <div className="card-validation mt-2 text-xs text-red-500">{errorMessage}</div>}
    </div>
  )
}

export { CardElement }
